import { useContext } from 'react'

import AppContext from '../store/AppContext'
import get from '../utils/lodashUtils/get'
import CostFormat from './CostFormat'

const CURRENCY_SYMBOL = {
	INR: '\u20B9',
	SGD: '\u0024',
	AUD: '\u0024',
	EUR: '\u20AC',
	USD: '\u0024',
	AED: 'AED',
	GBP: '\u00A3',
}

const DisplayPrice = ({
	objectData,
	path,
	defaultValue,
	fetchCurrency,
	prefixValue,
	enablePrefix = true,
	reduxCurrency,
	ignoreComma,
}) => {
	const [{ displayCurrency }] = useContext(AppContext)

	const myPrice = get(objectData, path, defaultValue)
	let currencyValue =
		CURRENCY_SYMBOL[prefixValue || reduxCurrency || displayCurrency]
	if (fetchCurrency) {
		currencyValue = objectData.currency
	}

	return (
		<CostFormat
			cost={myPrice}
			enablePrefix={enablePrefix}
			prefix={prefixValue || currencyValue}
			ignoreComma={ignoreComma}
		/>
	)
}

export default DisplayPrice
